/* tslint:disable */
/* eslint-disable */
export enum LoyaltyProvider {
  Card = 'CARD',
  Digitalhub = 'DIGITALHUB',
  None = 'NONE'
}
